import { View } from '@react-pdf/renderer'
import React from 'react'
import { pdfTableRowStyle } from './PdfTableStyles'

interface PdfUnsplittableTableRowProps {
  children: React.ReactNode
}

/**
 * PDF table row which is always kept on a single page. Rows with user data go into
 * {@link PdfSplittableTableRow}, since a row taller than a page would be drawn over.
 */
export const PdfUnsplittableTableRow = ({
  children
}: PdfUnsplittableTableRowProps): React.ReactElement => (
  <View style={pdfTableRowStyle} wrap={false}>
    {children}
  </View>
)
